export default {
  email: 'haseeb@haseebanwar.com',
  linkedin: 'haseeb-anwar',
  twitter: 'HaseebAnwar_',
  facebook: 'haseebanwar99',
  github: 'haseebanwar',
  medium: 'haseeb-anwar',
};
